import styled, { css } from 'styled-components';

import { SMALL_SCREEN_HEIGHT, SMALL_SCREEN_WIDTH } from '../_constants';

export const StyledAudioCallModal = styled.div<{
  $isFullScreen: boolean;
  $isDragging: boolean;
}>`
  margin: 0;
  padding: 0;
  position: fixed;
  z-index: 1049;
  user-select: none;
  ${({ $isFullScreen }) =>
    $isFullScreen
      ? css`
          inset: 0;
          width: 100vw;
          height: 100vh;
        `
      : css`
          width: ${SMALL_SCREEN_WIDTH}px;
          height: ${SMALL_SCREEN_HEIGHT}px;
        `}
  ${({ $isDragging }) =>
    $isDragging
      ? css`
          cursor: grabbing;
        `
      : ''}
`;
